/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Environment variable names for consistent environment variable references across the application</blockquote>
 * 
 * @example
 * ```typescript
 * import { ENVIRONMENT_VALUES } from '@shared/utils';
 * 
 * const dbUrl = process.env[ENVIRONMENT_VALUES.DATABASE.POSTGRES_URL];
 * ```
 * 
 * Environment variables are organized by category:
 * - DATABASE: Database connection variables
 * - AUTH: Authentication and security variables
 * - ANALYTICS: Analytics and tracking variables
 * - LOGGING: Logging and environment detection variables
 * - EMAIL: Email service variables
 * - TESTING: Testing-specific variables
 */
export const ENVIRONMENT_VALUES = {
  DATABASE: {
    POSTGRES_URL: 'POSTGRES_URL',
    LOCAL_POSTGRES_URL: 'LOCAL_POSTGRES_URL',
    OVERRIDE_POSTGRES_URL: 'OVERRIDE_POSTGRES_URL'
  },
  AUTH: {
    AUTH_SECRET: 'AUTH_SECRET',
    AUTH_JWT_EXPIRY: 'AUTH_JWT_EXPIRY',
    AUTH_SESSION_MAX_AGE: 'AUTH_SESSION_MAX_AGE',
    NEXTAUTH_URL: 'NEXTAUTH_URL'
  },
  ANALYTICS: {
    NEXT_PUBLIC_POSTHOG_KEY: 'NEXT_PUBLIC_POSTHOG_KEY',
    NEXT_PUBLIC_POSTHOG_HOST: 'NEXT_PUBLIC_POSTHOG_HOST'
  },
  LOGGING: {
    NODE_ENV: 'NODE_ENV',
    VERCEL_ENV: 'VERCEL_ENV',
    VERCEL_PROJECT_PRODUCTION_URL: 'VERCEL_PROJECT_PRODUCTION_URL',
    VERCEL_BRANCH_URL: 'VERCEL_BRANCH_URL',
    LOG_LEVEL: 'LOG_LEVEL',
    DEBUG: 'DEBUG',
    DEBUG_AUTH: 'DEBUG_AUTH',
    AXIOM_DATASET: 'AXIOM_DATASET',
    AXIOM_TOKEN: 'AXIOM_TOKEN'
  },
  EMAIL: {
    RESEND_API_KEY: 'RESEND_API_KEY',
    EMAIL_FROM: 'EMAIL_FROM',
    EMAIL_REPLY_TO: 'EMAIL_REPLY_TO'
  },
  TESTING: {
    TEST_ENV_FILE: '.env.test.local'
  }
} as const; 